import styled from '@emotion/styled'

export const Container = styled('div')`
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
`
